module.exports = "new-module/inner";


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/browser-field/~/new-module/inner.js
 ** module id = 14
 ** module chunks = 0
 **/